import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

class ProductSku extends HTMLElement {
    connectedCallback() {
        const closestSection = this.closest('.shopify-section, dialog');
        if (!closestSection) return;
        closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateSku);
    }

    disconnectedCallback() {
        const closestSection = this.closest('.shopify-section, dialog');
        if (!closestSection) return;
        closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateSku);
    }

    /**
   * Updates the sku.
   * @param {VariantUpdateEvent} event - new variants
   */
    updateSku = (event) => {
        const { detail } = event;

        const newSku = detail.data.html.querySelector("[data-sku]");
        const skuEl = this.querySelector('[data-sku]');

        if (!skuEl || !newSku) return;
        
        if (skuEl.innerHTML !== newSku.innerHTML) {
            skuEl.replaceWith(newSku);
        }
    }

}

if (!customElements.get('product-sku')) {
  customElements.define('product-sku', ProductSku);
}